import { gql } from '@apollo/client';
import type { SessionResponse } from '../../graphql/rest-link/types';

export const GET_SESSION = gql`
  query GetSession($eventUniqueCode: ID!) {
    getSession(eventUniqueCode: $eventUniqueCode)
      @rest(
        type: "SessionResponse"
        path: "/v2/api/session/?code={args.eventUniqueCode}"
        method: "GET"
        endpoint: "bff"
      ) {
      user
      roles
      featureFlags
      uuid
    }
  }
`;

export type GetSessionVariables = {
  eventUniqueCode?: string;
};

export type GetSessionData = {
  getSession: SessionResponse;
};
